/*
 * This is the big circular play button that appears on the item page.
 * Video.js already has this logic but not the styling, so we merely need to extend
 * videojs.BigPlayButton.
 */
import videojs from 'video.js';

import template from 'bundles/videojs/layout/circlePlayButton.html';

import 'css!bundles/videojs/css/circlePlayButton';

const KEY_ENTER = 'Enter';
const KEY_SPACE = ' ';

class CirclePlayButton extends videojs.getComponent('BigPlayButton') {
  handleClick() {
    this.hide();
    this.player_.play();
  }

  createEl() {
    const ClickableComponent = videojs.getComponent('ClickableComponent');
    return ClickableComponent.prototype.createEl.call(
      this,
      'div',
      {
        className: 'vjs-circle-play-button',
        innerHTML: template(),
      },
      {
        'aria-label': 'play video',
        'aria-live': 'off',
      }
    );
  }

  handleKeyDown(e) {
    if (e.key === KEY_ENTER || e.key === KEY_SPACE) {
      this.hide();
      this.player_.play();
      e.preventDefault();
      e.stopPropagation();
    }
  }
}

videojs.registerComponent('CirclePlayButton', CirclePlayButton);
